module.exports = __webpack_public_path__ + "img/credit_card_payment.aea8cdac.svg";